import { DOCUMENT_MODE } from "../../../constants/document";
import DummyCommand from "../dummyCommand";
import AddDocHTMLComponentCommand from "./addDocHTMLComponentCommand";
import AddTemplateHTMLComponentCommand from "./addTemplateHTMLComponentCommand";

class AddHTMLFactory {
  static getCommand(mode, componentData) {
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new AddDocHTMLComponentCommand(componentData, mode);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new AddTemplateHTMLComponentCommand(componentData, mode);
    }
    return new DummyCommand();
  }
}

export default AddHTMLFactory;
